"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicRoute = void 0;
exports.PublicRoute = {
    LivelinessCheck: '/health/alive',
    ReadinessCheck: '/health/ready',
};
//# sourceMappingURL=routes-public-guest.js.map